import React from "react";
import {
    Box,
    Button,
    Checkbox,
    Flex,
    Grid,
    IconButton,
    Tag,
    Text,
    Tooltip,
} from "@chakra-ui/react";
import { formatDate, formatDateTime } from "utils/dateUtils/dateUtils";
import { IoImage } from "react-icons/io5";
import { EditIcon } from "@chakra-ui/icons";

interface CardProps {
    data: any[];
    // setSelectedAdPath: (value: React.SetStateAction<string>) => void;
    // setIsImageModalOpen: (value: React.SetStateAction<boolean>) => void;
    handleEdit: any;
}

export default function PaymentCardView({
    data,
    // setSelectedAdPath,
    // setIsImageModalOpen,
    handleEdit
}: CardProps) {
    return (
        <>
            <Grid templateColumns="1fr" gap={4}>
                {data?.map((ad: any) => {
                    return (
                        <Box
                            key={ad._id}
                            p={4}
                            shadow="base"
                            borderRadius="lg"
                            bg="white"
                        >
                            <Flex justify="space-between" mb={2}>
                                <Text
                                    fontWeight="bold"
                                    color="teal.500"
                                    isTruncated={true}
                                    w={"10rem"}
                                >
                                    Provider:
                                </Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text isTruncated maxW={"70vw"} >
                                    Transaction No.:
                                </Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text maxW={"70vw"} >
                                    Amount:
                                </Text>
                            </Flex>
                        </Box>
                    );
                })}
            </Grid>
        </>
    );
}
